export default {
  login_microsoft: { id: 'login_microsoft' },
}
